import React, {useState} from 'react';
import {Flex, AvatarGroup, useTheme} from '@chakra-ui/react';
import {TextG12} from '../typography';
import {UsersListModal} from '../UsersList';
import {useFetchPlaceInterestedUsers} from '../../hooks/useFetchPlace';
import UserAvatar from '../UserAvatar';

interface PlaceInterestedDisplayProps {
  placeId: string;
}

const PlaceInterestedDisplay: React.FC<PlaceInterestedDisplayProps> = ({placeId}) => {
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Fetch first page to show avatars
  const {data} = useFetchPlaceInterestedUsers(placeId);
  const firstPageUsers = data?.pages[0]?.data?.data || [];
  const totalCount = data?.pages[0]?.data?.total || 0;
  
  // Create array with real users from first page + placeholders for remaining count
  const placeholdersNeeded = Math.max(0, totalCount - firstPageUsers.length);
  const placeholders = Array(placeholdersNeeded).fill({user_id: null, name: '', handle: ''});
  const displayUsers = [...firstPageUsers, ...placeholders];

  if (totalCount === 0) return null;

  return (
    <>
      <Flex
        gap={2}
        w="100%"
        align="center"
        wrap="wrap"
        cursor="pointer"
        onClick={() => setIsModalOpen(true)}
        mt={2}
        mb={2}
        _hover={{opacity: 0.8}}
        transition="opacity 0.2s">
        <AvatarGroup size="sm" max={3} spacing={-2}>
          {displayUsers.map((user, index) => (
            <UserAvatar
              key={user.user_id || `placeholder-${index}`}
              user={(user.user_id ? {
                id: user.user_id,
                name: user.name,
                surname: user.surname,
                handle: user.handle,
                profilePhotoUrl: user.profile_photo_url,
              } : undefined) as any}
              size="sm"
              avatar_image={user.profile_photo_url || undefined}
              sx={{border: '2px solid white'}}
            />
          ))}
        </AvatarGroup>
        <TextG12 fontWeight={'500'} color={theme.colors.lightBlack}>
          {totalCount} {totalCount === 1 ? 'Neighbor' : 'Neighbors'} Interested
        </TextG12>
      </Flex>

      <UsersListModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Interested"
        totalCount={totalCount}
        fetchUsersHook={useFetchPlaceInterestedUsers}
        entityId={placeId}
        chatRoute={`/place/${placeId}/chat`}
      />
    </>
  );
};

export default PlaceInterestedDisplay;
